<template>
  <div class="v-toggle-component">
    <input type="checkbox" :id="id" :name="id" @input="$emit('update:value', $event.target.checked)" :checked="value" class="v-toggle-input" />
    <label :for="id" class="v-toggle-label">
      <div class="v-toggle-label-text-wrapper">
        <p class="v-toggle-label-text" :class="{simple}">{{ label }}</p>
        <div class="explanation-wrapper">
          <p class="explanation-text">{{ explanation }}</p>
        </div>
      </div>
      <div class="v-toggle-button" :class="[[value ? 'on' : 'off'], {simple}, color ]">
        <span v-if="!simple" class="v-toggle-button-text">{{ text }}</span>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'GrmSwitch',
  props: {
    id: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    onText: {
      type: String,
      default: function () {return this.$t('common.on')}
    },
    offText: {
      type: String,
      default: function () {return this.$t('common.off')}
    },
    value: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    },
    simple: {
      type: Boolean,
      default: false
    },
    explanation: {
      type: String,
      default: ''
    }
  },
  computed: {
    text() {
      return this.value ? this.onText : this.offText;
    }
  },
}
</script>

<style lang="scss" scoped>
.v-toggle-component {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px 0;
  pointer-events: none;
}
.v-toggle-input {
  display: none;
}
.v-toggle-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.v-toggle-label-text-wrapper {
  padding-right: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px 0;
}
.v-toggle-label-text {
  font-size: 14px;
  &.simple {
    font-size: 13px;
  }
}
.v-toggle-button-text {
  padding: 0 6px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  transition: 0.2s ease-out;
  pointer-events: none;
}
.explanation-wrapper {}
.explanation-text {
  font-size: 13px;
  color: #999;
  line-height: 1.6;
}
.v-toggle-button {
  min-width: 72px;
  height: 24px;
  border-radius: 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  position: relative;
  cursor: pointer;
  pointer-events: auto;
  transition: 0.2s ease-out;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    width: 26px;
    height: 26px;
    border-radius: 100%;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.4);
    transition: 0.2s ease-out;
    z-index: 1;
    pointer-events: none;
  }
  &.simple {
    min-width: 40px;
    height: 10px;
    align-self: center;
    &::before {
      width: 18px;
      height: 18px;
    }
  }
  &.on {
    padding-right: 26px;
    background-color: #36f;
    &::before {
      background-color: $mainColor;
      left: 100%;
      transform: translateX(-100%);
    }
    .v-toggle-button-text {
      transform: translateX(2px);
    }
  }
  &.off {
    padding-left: 26px;
    color: #aaa;
    background-color: #333;
    &::before {
      background-color: #666;
    }
    &.red {
      &::before {
        background-color: #fe2842;
      }
    }
    .v-toggle-button-text {
      transform: translateX(-2px);
    }
  }
}
</style>